/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FixDanglingInstrumentLinkStatusRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixDanglingInstrumentLinkStatus.pb'
import {FixDanglingInstrumentLinkStatusResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixDanglingInstrumentLinkStatus.pb'


export const fixDanglingInstrumentLinkStatus = (request: FixDanglingInstrumentLinkStatusRequest, options?: CashRequestOptions) => post<FixDanglingInstrumentLinkStatusRequest, FixDanglingInstrumentLinkStatusResponse>("/2.0/cash/fix-dangling-instrument-link-status", request, {...options, rejectOnError: true })